import React from 'react';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { publishSuccessModalMessages as messages } from '../../ClasstivitySchedulerForm.messages';

export const PublishSuccessModal = () => (
  <Confirm title={<Message message={messages.title} />} acceptNode={<Message message={messages.accept} />} isOpen>
    <Message message={messages.body} />
  </Confirm>
);
